<template>
  <InputBaseAntd
    :class="['tw:w-full', { prefix: attrs['addon-before'] }]"
    v-bind="attrs"
    :borderless="true"
    size="middle"
  >
    <template v-for="(comp, name) in slots" :key="name" v-slot:[name]>
      <component :is="comp" />
    </template>
  </InputBaseAntd>
</template>
<script lang="ts">
import { useAttrs, useSlots, defineComponent } from 'vue'
import InputBaseAntd from '@/components/base/antd/InputBaseAntd.vue'

export default defineComponent({
  name: 'mars-input',
  inheritAttrs: false,
  components: {
    InputBaseAntd,
  },
  setup() {
    const attrs = useAttrs()
    const slots = useSlots()
    return {
      attrs,
      slots,
    }
  },
})
</script>
